import Header from '@/components/layout/Header'
import Footer from '@/components/layout/Footer'
import Hero from '@/components/landing/Hero'
import Features from '@/components/landing/Features'
import WordPools from '@/components/landing/WordPools'
import Platforms from '@/components/landing/Platforms'
import CTA from '@/components/landing/CTA'

const Landing = () => {
  return (
    <div className="min-h-screen">
      <Header />
      <main>
        <Hero />
        <Features />
        <WordPools />
        <Platforms />
        <CTA />
      </main>
      <Footer />
    </div>
  )
}

export default Landing
